import React from "react";
import {browserHistory} from "react-router";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import immutable from "immutable";
import * as Moment from "moment";
import SearchForm from "./tc-verify/search-form2.jsx";

export default class TCVerify2 extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            role: context.getRouteParam(this, "role"),
            search: null
        };

        this.onFieldChange = this.onFieldChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onTcItemChecked = this.onTcItemChecked.bind(this);
        this.onVerify = this.onVerify.bind(this);
        this.search = this.search.bind(this);
        this.updateStatusCount = this.updateStatusCount.bind(this);
        this.onSortChange = this.onSortChange.bind(this);
    }

    onFieldChange(patch, callback) {
        let map = immutable.fromJS(this.state);        
        const clone = map.mergeDeep(patch).toJS();

        if (patch.search !== undefined) {
            if (patch.search.navigation !== undefined) {
                clone.search.navigation = patch.search.navigation;
            } 

            if (patch.search.timecardList !== undefined) {
                clone.search.timecardList = patch.search.timecardList;
            }
        }

        this.setState(clone, function() {          
            if (callback) callback();
        });            
    }

    onSortChange(sort, callback) {
        let clone = immutable.fromJS(this.state).toJS();
        
        if (clone.search.sortExpression.indexOf(sort) > -1) {
            if (clone.search.sortExpression.indexOf('DESC') > -1) {
                clone.search.sortExpression = sort;
            }
            else {
                clone.search.sortExpression = sort + ' DESC';
            }
        }
        else {
            clone.search.sortExpression = sort;
        }

        this.setState(clone, function() {          
            if (callback) callback();
        });
    }

    onNavigate(page) {
        let self = this;
        self.state.search.page = page;
        self.state.search.timecardList.isAllSelected = false;
        this.search();
    }    

    onSearch() {
        let self = this;
        let vm = self.state;
        vm.search.page = 0;
        this.search();
    }
    
    onTcItemChecked(tcId) {
        let map = immutable.fromJS(this.state);
        let clone = map.toJS();
        if (tcId === "all") {
            clone.search.timecardList.isAllSelected = !clone.search.timecardList.isAllSelected;
            for(let i=0; i<clone.search.timecardList.timecards.length; i++) {
                let tc = clone.search.timecardList.timecards[i].timecardSummary;
                let totalHours = parseFloat(tc.totalHour) + (parseFloat(tc.totalMin) / 60);
                if (totalHours > 0 && tc.isEdited == false && 
                    (
                        tc.statusDescription.toLowerCase() == "submitted" ||
                        (tc.statusDescription.toLowerCase() == "verified" && tc.imageFileName.toLowerCase().indexOf('/preverify.gif') > -1)
                    )) {
                    tc.isChecked = clone.search.timecardList.isAllSelected;
                }
            }
        } else {
            for(let i=0; i<clone.search.timecardList.timecards.length; i++) {
                let tc = clone.search.timecardList.timecards[i].timecardSummary;
                if (tc.timecardId == tcId) {    
                    tc.isChecked = tc.isChecked || false;
                    tc.isChecked = !tc.isChecked;
                    if (tc.submittedDate != null) {
                        clone.search.timecardList.isAllSelected = false;
                    }         
                    break;
                }
            }            
        }            
        this.setState(clone);
    }

    onVerify() {
        let clone = this.state;
        context.message(
                {
                    show: true,
                    type: "loading",
                    message: "Processing. Please wait...",
                });
        let self = this;        
        let timecards = [];
        for(let i=0; i<clone.search.timecardList.timecards.length; i++) {
            let tc = clone.search.timecardList.timecards[i].timecardSummary;
            let totalHours = parseFloat(tc.totalHour) + (parseFloat(tc.totalMin) / 60);
            // if (!(tc.isEdited || tc.isIncomplete || tc.hasUnapprovedPto || totalHours == 0 || tc.statusDescription.toLowerCase() != 'submitted') && tc.isChecked) {
            if (totalHours > 0 && tc.isEdited == false && 
                (
                    tc.statusDescription.toLowerCase() == "submitted" ||  
                    (tc.statusDescription.toLowerCase() == "verified" && tc.imageFileName.toLowerCase().indexOf('/preverify.gif') > -1)
                ) && tc.isChecked) {
                timecards.push(tc.timecardId);
            }
        }
        let submitted = clone.search.status == "saved" ? 0 : 1;
        ajax.api().post("prepare-timecard-verification2",
            {
                timecards: timecards,
                role: clone.role,
                submitted: submitted,                
                mainUrl: ""
            })
        .then(function(res) {
            browserHistory.push(context.routeUrl(`${clone.role}/tc-approval/${submitted}/${'2'}`));
        }).catch(function(err) {
            let data = err.response.data;
            context.message({
                show: true,
                type:"error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }

    componentDidMount() {
        let self = this;
        let vm = self.state;

        ajax.vm().get("tc-verify2/" + this.state.role)
            .then(function(res) {
                self.setState(res.data);
                self.updateStatusCount("unverified", 'countSubmittedPrevious', new Date(Moment.default(res.data.search.weekEndingDate).add(-7, 'days')), res.data.search.approverId, res.data.peopleId);
                self.updateStatusCount("unverified", 'countSubmittedNext', new Date(Moment.default(res.data.search.weekEndingDate).add(7, 'days')), res.data.search.approverId, res.data.peopleId);
                self.search();
            })
            .catch(function (err) {
                let data = err.response === undefined ? err : err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    updateStatusCount(status, property, weekEndingDate, userId, peopleId) {
        let self = this;

        if (weekEndingDate instanceof Date) {
            weekEndingDate = (weekEndingDate.getMonth() + 1) + '/' + weekEndingDate.getDate() + '/' + weekEndingDate.getFullYear();
        }
           
        ajax.api().get(`get-timecard-count-by-status/${self.state.role}/${status}`, {
            params : {
                userId: userId,
                weekEndingDate: weekEndingDate,
                peopleId: peopleId == '' ? null : peopleId,
                version: '2'
            }
        })
        .then(function(res) {
            let clone = self.state.search;
            if (res.data && !isNaN(res.data)) {
                clone[property] = parseInt(res.data);
            }
            self.setState({search: clone});
        })
        .catch(function(err) {
            let data = err.response.data;
            context.message({
                show: true,
                type:"error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }
    
    search() {
        let self = this;                
        let vm = self.state;      
        context.message({show:true, type: "loading", message:"Searching. Please wait..."});
        var weekEndingDate = vm.search.weekEndingDate;

        if (vm.search.weekEndingDate instanceof Date) {
            weekEndingDate = (vm.search.weekEndingDate.getMonth() + 1) + '/' + vm.search.weekEndingDate.getDate() + '/' + vm.search.weekEndingDate.getFullYear();
        }

        ajax.legacy().get("get-timecard-list/"+ vm.role + "/" + vm.search.status, {
            params : {
                p: vm.search.page,
                pz: vm.search.pageSize,
                peopleId: vm.search.peopleId,
                weekEndingDate: weekEndingDate,
                approverId: vm.search.approverId,
                version: "2",
                sortExpression: vm.search.sortExpression
            }
        })
        .then(function(res) {               
            self.state.search.timecardList.timecards = [];
            self.state.search.timecardList.isAllSelected = false;
            let map = immutable.fromJS(self.state);                
            self.setState(map.mergeDeep({
                search : {
                    timecardList: res.data,
                }
            }).toJS());                 
            context.message({show:false});
        })
        .catch(function(err) {
            let data = err.response.data;
            context.message({
                show: true,
                type:"error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }

    render() {    
        return(
            <div className="ap-form-container">
                <div className="container">
                    <div className="row hidden-sm hidden-xs">
                        <div className="col-md-12">
                            <h2 className="text-center ap-title verify-timecard">Verify Timecard</h2>
                        </div>
                    </div>
                </div>
                <SearchForm onSearch={this.onSearch} onFieldChange={this.onFieldChange} vm={this.state.search} role={this.state.role}
                    onNavigate={this.onNavigate} onTcItemChecked={this.onTcItemChecked} onVerify={this.onVerify} updateStatusCount={this.updateStatusCount}
                    onSortChange={this.onSortChange} />
            </div>
            );
    }
}